import React from "react";
import { Stack } from "@mui/material";
import type { OperandDto } from "../../../../../../types/resolver";
import { DerivedAttributeInput } from "../../DerivedAttributeInput";
import type { OperandTypeComponentProps } from "./types";

export interface DerivedAttributeOperandProps extends OperandTypeComponentProps {
    declaredDerivedAttributeNames: string[];
}

export const DerivedAttributeOperand: React.FC<DerivedAttributeOperandProps> = ({
    value,
    onChange,
    declaredDerivedAttributeNames,
}) => (
    <Stack spacing={1}>
        <DerivedAttributeInput
            value={String(value?.derivedAttributeName ?? "")}
            onChange={(name) =>
                onChange({
                    ...(value ?? {}),
                    operandType: "derivedAttribute",
                    derivedAttributeName: name,
                } as OperandDto)
            }
            existingNames={declaredDerivedAttributeNames}
            label="Derived attribute"
            placeholder="Select or type name and press Enter"
        />
    </Stack>
);
